<template>
    <div class="sorting cursor-pointer d-inline" @click="sorting">
        <i
            v-if="orderBy == ORDER_ASCENDING"
            class="fa fa-long-arrow-alt-up"
        ></i>
        <i
            v-else-if="orderBy == ORDER_DESCENDING"
            class="fa fa-long-arrow-alt-down"
        ></i>
        <i v-else class="fa fa-sort icon-grey"></i>
        {{ text }}
    </div>
</template>
<script>
const ORDER_ASCENDING = "asc";
const ORDER_DESCENDING = "desc";
export default {
    data() {
        return { ORDER_ASCENDING, ORDER_DESCENDING };
    },
    props: {
        // the order or the column (ascending or descending)
        orderBy: {
            type: String,
            default: ORDER_ASCENDING,
            validator: function (value) {
                // The value must match one of these strings
                return (
                    [ORDER_ASCENDING, ORDER_DESCENDING].indexOf(value) !== -1
                );
            }
        },
        text: {
            type: String,
            default: ""
        }
    },
    methods: {
        sorting() {
            this.$emit(
                "sorting",
                this.orderBy == ORDER_ASCENDING
                    ? ORDER_DESCENDING
                    : ORDER_ASCENDING
            );
        }
    }
};
</script>

<style scoped>
.sorting {
    user-select: none;
}
.sorting:not(:hover) > .icon-grey,
.icon-grey:not(:hover) > .icon-grey {
    color: #dddddd;
}
</style>
